/**
 * Created by luka on 23.02.2018.
 */


import {
    LOADING_WORKOUT_FAILED, WORKOUT_ALREADY_MISSED, WORKOUT_FETCH_DATA_SUCCESS,
    WORKOUT_LOADING
} from "../actions/types";
export function loadingWorkoutFailed(state = false, action) {
    switch (action.type) {
        case LOADING_WORKOUT_FAILED:
            return action.error;
        default:
            return state;
    }
}
export function workoutLoading(state = false, action) {
    switch (action.type) {
        case WORKOUT_LOADING:
            return action.isLoading;
        default:
            return state;
    }
}

export function workoutAlreadyMissed(state = false, action) {
    switch (action.type) {
        case WORKOUT_ALREADY_MISSED:
            return action;
        default:
            return state;
    }
}

export function workout(state = {}, action) {
    switch (action.type) {
        case WORKOUT_FETCH_DATA_SUCCESS:
            return action.day;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/workout/WorkoutReducer.js